export default __webpack_public_path__ + "static/media/sinfondo_logo.80065191.png";